module.exports = {"511802001":"东城街道","511802002":"西城街道","511802003":"河北街道","511802004":"青江街道","511802005":"大兴街道","511802101":"草坝镇","511802107":"上里镇","511802109":"晏场镇","511802110":"多营镇","511802111":"碧峰峡镇","511802112":"望鱼镇","511802113":"周公山镇","511802114":"八步镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/511802.json
// module id = 2511
// module chunks = 0